import { LimitsUpdatesHistoryEntity } from 'types';

import { createCrudApi } from './crud.api';

export const limitsUpdatesHistoryApi =
  createCrudApi<LimitsUpdatesHistoryEntity>('/limits-updates-history');
